import { normalizePointMaximumSize } from './puntoScharffCapacity'

const firstDefined = (...values) => values.find((value) => value !== undefined && value !== null)

/**
 * Sharf points reach the app in two shapes: API1 (scharffpoints/*) uses PascalCase and API2
 * (puntoscharff/search) uses camelCase. Everything downstream — the map, the district autofill and
 * the capacity tags — expects a single shape, so both are normalized here.
 */
export const normalizeScharffPoint = (point) => {
  if (!point || typeof point !== 'object') return point

  const location = firstDefined(point.Location, point.ubicacion, point.Ubicacion)

  return {
    ...point,
    ScharffPointId: firstDefined(point.ScharffPointId, point.puntoScharffId),
    Name: firstDefined(point.Name, point.nombre),
    Address: firstDefined(point.Address, point.direccion),
    DistritoId: firstDefined(point.DistritoId, point.distritoId),
    DistritoTexto: firstDefined(point.DistritoTexto, point.distrito),
    ProvinciaId: firstDefined(point.ProvinciaId, point.provinciaId),
    ProvinciaTexto: firstDefined(point.ProvinciaTexto, point.provincia),
    DepartamentoId: firstDefined(point.DepartamentoId, point.departamentoId),
    DepartamentoTexto: firstDefined(point.DepartamentoTexto, point.departamento),
    Location: location
      ? { Lat: firstDefined(location.Lat, location.lat), Lng: firstDefined(location.Lng, location.lng) }
      : null,
    AcceptsCashOnDelivery: firstDefined(
      point.AcceptsCashOnDelivery,
      point.acceptsCashOnDelivery,
      point.AdmitePagoContraEntrega,
      point.admitePagoContraEntrega
    ) === true,
    maximumSize: normalizePointMaximumSize(point),
  }
}

// The flag arrives as AcceptsCashOnDelivery from API1 and admitePagoContraEntrega from API2.
export const acceptsCashOnDelivery = (point) => !!point && firstDefined(
  point.AcceptsCashOnDelivery,
  point.acceptsCashOnDelivery,
  point.AdmitePagoContraEntrega,
  point.admitePagoContraEntrega
) === true;

export const normalizeScharffPoints = (points = []) =>
  Array.isArray(points) ? points.map(normalizeScharffPoint) : []
